import { getBooleanSchema, getNumberSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const DeadReportsSchema = Yup.object().shape({
  date: Yup.date().required('Date is required'),
  count: Yup.mixed<any>().when('unspecified', {
    is: true,
    then(schema) {
      return schema.notRequired();
    },
    otherwise() {
      return getNumberSchema('Count').integer('Count must be an integer.');
    },
  }),
  unspecified: getBooleanSchema('Unspecified', false),
});
